module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921014149_T.1a3204da.jpg";